import type { ThemeSettingsState } from '@sites/site-theme/src/state/theme.types';

import { DEFAULT_WEBSITE_FONT_COLOR } from '@sites/site-theme/src/config/font-color.const';
import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';
import { withFontColorDefault } from '@sites/site-theme/src/utils/font-color';
import { selectButtons, selectColors, selectFonts } from '@sites/site-theme/src/utils/selection';

/**
 * The theme an editor starts from, and what a site created outside the editor is given.
 *
 * Only a brand-new site with no typography saved at all follows the palette's `dark`. An old site —
 * including a saved-but-unpublished one — keeps the plain black it has always rendered.
 */
export function initialThemeSettings(
    themeSettings: ThemeSettingsState = {},
    isNewSite = false
): Required<ThemeSettingsState> {
    const defaultFontColor = isNewSite && !themeSettings.fonts ? ThemeColorNames.dark : DEFAULT_WEBSITE_FONT_COLOR;

    return {
        colors: selectColors(themeSettings.colors),
        fonts: withFontColorDefault(selectFonts(themeSettings.fonts), defaultFontColor),
        buttons: selectButtons(themeSettings.buttons),
    };
}
